import { useEffect, useRef, useState } from 'react';

export const Ellipsis = () => {
  const [e, setE] = useState(0);

  let dots = '.';
  for (let i = 0; i < e; i++) {
    dots += '.';
  }

  const interval = useRef(0);
  useEffect(() => {
    interval.current = setInterval(() => {
      setE((e) => (e === 2 ? 0 : e + 1));
    }, 500) as any;

    return () => {
      clearInterval(interval.current);
    };
  });

  return <div className="ellipsis">{dots}</div>;
};
